import { render } from "./SittingTeamDetails.vue?vue&type=template&id=cb0d54b6&scoped=true"
import script from "./SittingTeamDetails.vue?vue&type=script&lang=js"
export * from "./SittingTeamDetails.vue?vue&type=script&lang=js"

import "./SittingTeamDetails.vue?vue&type=style&index=0&id=cb0d54b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0d54b6"]])

export default __exports__